module.exports = require("!!vue-loader!../../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./parenthood.md");


//////////////////
// WEBPACK FOOTER
// ./src/assets/posts/parenthood.md
// module id = 28
// module chunks = 3